import { Component, Injector, Input, OnInit } from '@angular/core';
import { BasePermissionService } from 'tnx-admin-service/authorization/basepermission/services';
import { ModuleService } from 'tnx-admin-service/authorization/module/services';
import { PermissionService } from 'tnx-admin-service/authorization/permission/services';
import {
    ComponentContextService,
    DataFormBase,
    DropdownControlSchema,
    EntityPickerColumn,
    EntityPickerControlSchema,
    EventData,
    FormSchemaBase,
    Operator,
    TextAreaControlSchema,
    TextControlSchema,
} from 'tnx-shared';

@Component({
    selector: 'permission-form',
    templateUrl: './permission-form.component.html',
    styleUrls: ['./permission-form.component.scss'],
    providers: [ComponentContextService],
})
export class PermissionFormComponent extends DataFormBase implements OnInit {

    @Input() moduleCode: string = null;

    constructor(
        protected _injector: Injector,
        private _permissionService: PermissionService,
        private _basePermissionService: BasePermissionService,
        private _moduleService: ModuleService
    ) {
        super(_injector);
    }

    ngOnInit() {
        super.ngOnInit();
        this.setting.baseService = this._permissionService;
        this.setting.schema = <FormSchemaBase[]>[
            new DropdownControlSchema({
                field: 'idParent',
                label: 'Thuộc nhóm quyền',
                baseService: this._permissionService,
                displayField: 'name',
                valueField: 'id',
                fieldTree: 'idParent',
                valueParentRoot: null,
                isTree: true,
                defaultFilters: () => {
                    return [this.newFilter('moduleCode', Operator.equal, this.moduleCode)];
                }
            }),
            new TextControlSchema({
                field: 'name',
                label: 'Tên',
                required: true
            }),
            new DropdownControlSchema({
                field: 'type',
                label: 'Loại',
                baseService: this._masterDataService,
                groupCode: 'LOAI_QUYEN',
                displayField: 'name',
                valueField: 'code',
                required: true
            }),
            new TextControlSchema({
                field: 'orderNo',
                label: 'Thứ tự'
            }),
            new TextAreaControlSchema({
                field: 'description',
                label: 'Mô tả',
                mdWidth: 12,
                rows: 2
            }),
            new TextAreaControlSchema({
                field: 'basePermissionFreeTextTemp',
                label: 'Thêm nhanh quyền',
                mdWidth: 12,
                rows: 10
            }),
            new EntityPickerControlSchema({
                field: 'basePermissionIds',
                baseService: this._basePermissionService,
                title: 'Chọn quyền',
                mdWidth: 12,
                fieldSearchText: ['name', 'code', 'moduleCode'],
                columns: [
                    new EntityPickerColumn({
                        code: 'id',
                        label: 'Id',
                        operator: Operator.equal,
                        isSearchable: false,
                        isDisplay: false
                    }),
                    new EntityPickerColumn({
                        code: 'moduleCode',
                        label: 'Phân hệ',
                        operator: Operator.equal,
                        baseService: this._moduleService,
                        displayField: 'name',
                        valueField: 'code',
                        isSearchable: true,
                        isDisplay: true,
                        forceGetData: true,
                        width: '85px'
                    }),
                    new EntityPickerColumn({
                        code: 'name',
                        label: 'Tên',
                        operator: Operator.contain,
                        isSearchable: true
                    }),
                    new EntityPickerColumn({
                        code: 'code',
                        label: 'Mã',
                        operator: Operator.contain,
                        isSearchable: true,
                        isDisplay: true
                    }),
                ]
            })
        ];
    }

    async getDetailCustom() {
        return this._permissionService.getDetailCustom(this.model.data.id, this._commonService.guidEmpty());
    }

    async onFormInitialized(formEvent: EventData) {
        // tiền xử lý dữ liệu (ví dụ tổng hợp datasource), trước khi gọi api get detail
    }

    async modifyDetailData(data) {
        // chuyển sang Api xử lý
        // if (data.permissionHasBasePermissions) {
        //     data.basePermissionIds = data.permissionHasBasePermissions.map(x => x.idBasePermission);
        // }
    }

    async onBeforeSave() {
        if (this.model.data.basePermissionFreeTextTemp) {
            this.model.data.basePermissionFreeText =
                this.model.data.basePermissionFreeTextTemp
                    .split('\n')
                    .filter(x => x != '')
                    .map(x => x.trim());
        }
        this.model.data.moduleCode = this.moduleCode;
        return true;
    }

}

